import React, { useMemo } from "react";
import cx from "classnames";

import styles from "./sortBy.module.scss";
import { Dropdown } from "react-bootstrap";

interface ISortByAction {
  value: { sortBy: string; orderBy: string };
  // eslint-disable-next-line no-unused-vars
  onChange: (value: { sortBy: string; orderBy: string }) => void;
  sortOptions: { label: string; value: string }[];
}

const SortByAction = ({ value, onChange, sortOptions }: ISortByAction) => {
  const sortOrder = value.orderBy;
  const sortBy = value.sortBy;

  const sortByLabel = useMemo(() => {
    return sortOptions.find((item) => item.value === sortBy)?.label;
  }, [sortBy]);

  const toggleSortOrder = () => {
    onChange({
      ...value,
      orderBy: sortOrder === "ASC" ? "DESC" : "ASC",
    });
  };

  const handleSortByChange = (change: string) => {
    let sortOrderValue = sortOrder;

    if (sortBy === change) {
      sortOrderValue = sortOrder === "ASC" ? "DESC" : "ASC";
    }

    onChange({
      sortBy: change,
      orderBy: sortOrderValue,
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.details}>
        <div className={styles.title}>Sort by</div>
        <div className={styles.field}>
          {sortByLabel}
          <div
            className={cx(styles.indicator, styles[sortOrder])}
            onClick={toggleSortOrder}
          >
            <i
              className={cx(styles.arrow, styles.up, "paperflite-dropdown")}
            ></i>
            <i
              className={cx(styles.arrow, styles.down, "paperflite-dropdown")}
            ></i>
          </div>
        </div>
      </div>
      <Dropdown>
        <Dropdown.Toggle className={styles.button} as={"button"}>
          <i className={cx(styles.icon, "paperflite-menu")}></i>
        </Dropdown.Toggle>
        <Dropdown.Menu
          className={styles.dropdown}
          popperConfig={{
            modifiers: [
              {
                name: "offset",
                options: {
                  offset: [0, 6],
                },
              },
            ],
          }}
        >
          {sortOptions.map((item, index) => {
            const active = item.label === sortByLabel;
            return (
              <Dropdown.Item
                key={index}
                className={cx(styles.dropdownItem, { [styles.active]: active })}
                onClick={() => handleSortByChange(item.value)}
              >
                {item.label}
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export { SortByAction };